module.exports = __webpack_public_path__ + "img/horizontal_6_5_0.009cb033.png";